var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.hidden && 'd-none']},[_c('div',{staticClass:"my-4 border-bottom",staticStyle:{"border-color":"#D2D6DC !important"}},[_c('h2',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }